import { c as _c } from "react/compiler-runtime";
import { formatDate } from '@/shared/formatters';
import type { IdentificacaoSentenca } from '../../../types/sentencaArbitral.types';
import { TEXTOS_SENTENCA_ARBITRAL } from './secoesSentencaArbitral';
export function SecaoIdentificacaoIntro() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="px-[37px] pb-5"><p className="text-[14px] leading-[1.45] text-neutral-600">{TEXTOS_SENTENCA_ARBITRAL.identificacaoIntro}</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
interface TabelaIdentificacaoSentencaProps {
  identificacao: IdentificacaoSentenca;
}
export function TabelaIdentificacaoSentenca(t0) {
  const $ = _c(30);
  const {
    identificacao
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="bg-brand-50 grid grid-cols-2 px-5 py-[11px] text-[11px] font-semibold tracking-[0.5px] text-neutral-500 uppercase"><div>{TEXTOS_SENTENCA_ARBITRAL.identificacaoColunaProcedimento}</div><div>{TEXTOS_SENTENCA_ARBITRAL.identificacaoColunaReferencias}</div></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== identificacao.localSentenca) {
    t2 = <CampoIdentificacao rotulo={"Local da senten\xE7a"} valor={identificacao.localSentenca} />;
    $[1] = identificacao.localSentenca;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== identificacao.instituicaoArbitral) {
    t3 = <CampoIdentificacao rotulo={"Institui\xE7\xE3o arbitral"} valor={identificacao.instituicaoArbitral} />;
    $[3] = identificacao.instituicaoArbitral;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== identificacao.requerimentoNumero) {
    t4 = <CampoIdentificacao destacado={true} rotulo={"Requerimento n\xBA"} valor={identificacao.requerimentoNumero} />;
    $[5] = identificacao.requerimentoNumero;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== identificacao.termoArbitragemId) {
    t5 = <CampoIdentificacao destacado={true} rotulo="Termo de arbitragem" valor={identificacao.termoArbitragemId} />;
    $[7] = identificacao.termoArbitragemId;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== identificacao.proferidaEm) {
    t6 = formatDate(identificacao.proferidaEm);
    $[9] = identificacao.proferidaEm;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <CampoIdentificacao rotulo={"Data da senten\xE7a"} valor={t6} />;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== identificacao.profissionalResponsavel) {
    t8 = <CampoIdentificacao rotulo={"Profissional respons\xE1vel"} valor={identificacao.profissionalResponsavel} />;
    $[13] = identificacao.profissionalResponsavel;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== identificacao.plataformaUrl || $[16] !== identificacao.plataformaUrlExibicao) {
    t9 = <CampoIdentificacao href={identificacao.plataformaUrl} rotulo="Plataforma digital" valor={identificacao.plataformaUrlExibicao} />;
    $[15] = identificacao.plataformaUrl;
    $[16] = identificacao.plataformaUrlExibicao;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== identificacao.autenticidadeUrl || $[19] !== identificacao.autenticidadeUrlExibicao) {
    t10 = <CampoIdentificacao href={identificacao.autenticidadeUrl} rotulo="Autenticidade dos documentos" valor={identificacao.autenticidadeUrlExibicao} />;
    $[18] = identificacao.autenticidadeUrl;
    $[19] = identificacao.autenticidadeUrlExibicao;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t2 || $[23] !== t3 || $[24] !== t4 || $[25] !== t5 || $[26] !== t7 || $[27] !== t8 || $[28] !== t9) {
    t11 = <div className="px-[37px] pb-[26px]"><div className="overflow-hidden rounded-[8px] border border-solid border-neutral-200">{t1}<div className="grid grid-cols-1 gap-x-6 gap-y-[14px] border-t border-solid border-neutral-200 px-5 py-4 sm:grid-cols-2">{t2}{t3}{t4}{t5}{t7}{t8}{t9}{t10}</div></div></div>;
    $[21] = t10;
    $[22] = t2;
    $[23] = t3;
    $[24] = t4;
    $[25] = t5;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  return t11;
}
interface CampoIdentificacaoProps {
  rotulo: string;
  valor: string;
  destacado?: boolean;
  href?: string;
}
function CampoIdentificacao(t0) {
  const $ = _c(9);
  const {
    rotulo,
    valor,
    destacado: t1,
    href
  } = t0;
  const destacado = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== rotulo) {
    t2 = <div className="mb-[2px] text-[11px] tracking-[0.4px] text-neutral-400 uppercase">{rotulo}</div>;
    $[0] = rotulo;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== destacado || $[3] !== href || $[4] !== valor) {
    t3 = href ? <a className="text-brand-600 text-[13px] font-bold break-all hover:underline" href={href} rel="noopener noreferrer" target="_blank">{valor}</a> : <div className={destacado ? "text-brand-600 text-[13px] leading-[1.4] font-semibold" : "text-[13px] leading-[1.4] font-medium text-neutral-700"}>{valor}</div>;
    $[2] = destacado;
    $[3] = href;
    $[4] = valor;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div>{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}